import React, { useMemo, lazy } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../lib/i18n';
// Generate array of 32 image URLs
const beginningImages = Array.from({
  length: 32
}, (_, i) => `https://cdn.rawproductionsgmbh.de/caro/begin/begin-${i + 1}.jpg`);
function getRandomImages(count: number): string[] {
  const shuffled = [...beginningImages].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
export function CaroBeginning() {
  const {
    t
  } = useTranslation();
  // Select 8 images total (max needed for desktop)
  const images = useMemo(() => getRandomImages(8), []);
  return <section className="py-20 px-4 bg-surface" data-id="element-35">
      <div className="max-w-7xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#1A1A1A] mb-4" data-id="element-38">
            {t.beginning.title}
          </h2>
          <div className="w-16 h-1 bg-hotpink mx-auto rounded-full mb-6" data-id="element-39" />
          <p className="text-text-secondary text-lg max-w-2xl mx-auto font-light leading-relaxed" data-id="element-40">
            {t.beginning.description}
          </p>
        </motion.div>

        {/* Grid Container */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-41">
          {images.map((src, index) => <motion.div key={src} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }}
        // Mobile: Show first 6 images (index 0-5). Desktop: Show all 8 images.
        className={`aspect-[3/4] rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group ${index >= 6 ? 'hidden md:block' : ''}`} data-id="element-42">
              <img src={src} alt={`Caro Beginning ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" data-id="element-43" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-44" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}